var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("defs", null,
            React.createElement("filter", { id: "btn_morecolor_svg__a" },
                React.createElement("feColorMatrix", { in: "SourceGraphic", type: "matrix", values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0" }))),
        React.createElement("g", { stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
            React.createElement("g", { filter: "url(#btn_morecolor_svg__a)" },
                React.createElement("rect", { fill: "currentColor", x: 4, y: 4, width: 40, height: 40, rx: 6 })),
            React.createElement("rect", { stroke: "currentColor", strokeWidth: 2, fill: "#FFF", x: 4, y: 4, width: 40, height: 40, rx: 6 }),
            React.createElement("circle", { fill: "currentColor", cx: 16, cy: 24, r: 2 }),
            React.createElement("circle", { fill: "currentColor", cx: 24, cy: 24, r: 2 }),
            React.createElement("circle", { fill: "currentColor", cx: 32, cy: 24, r: 2 }))));
});
